<template>
	<div class="add-dict-data">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="dictForm.id ? $t('addDictData.edit') : $t('addDictData.add')"
			:visible.sync="dialogDict"
			width="35%"
			top="9vh"
			@open="open"
			@closed="closeDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					v-loading="loading"
					:rules="rules"
					ref="dictForm"
					label-width="80px"
					:model="dictForm">
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item
								:label="$t('addDictData.dictType')"
								prop="dictType"
								:error="error.dictName">
								<el-input
									v-model="dictForm.type"
									disabled="disabled"
									:placeholder="$t('addDictData.pDictType')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<div class="menu-scroll">
						<el-row
							:gutter="20"
							v-for="(item, index) in dictForm.codesLabels"
							:key="item.key"
							class="b-t-m">
							<el-col :span="24">
								<el-form-item
									:label="$t('addDictData.label')"
									:prop="'codesLabels.' + index + '.label'"
									:error="error.dictType">
									<el-input
										v-model="item.label"
										:disabled="!item.lang || item.lang === ''"
										:placeholder="$t('addDictData.pDictLabel')"
										autocomplete="off">
										<el-select
											style="min-width: 150px"
											v-model="item.lang"
											:no-data-text="$t('common.noData')"
											:no-match-text="$t('common.noData')"
											:key="itemKey"
											@change="changeMenu"
											slot="prepend"
											placeholder="请选择">
											<el-option
												v-for="item in langList"
												:key="item.id"
												:label="item.label"
												:value="item.value"
												:disabled="item.disabled">
											</el-option>
										</el-select>
										<el-button
											slot="append"
											icon="el-icon-plus"
											v-if="index === 0"
											@click="addLang"
											>增加菜单语言</el-button
										>
										<el-button
											slot="append"
											icon="el-icon-delete"
											v-else
											@click="delLang(item)"
											>删除菜单语言</el-button
										>
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</div>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item
								:label="$t('addDictData.value')"
								prop="value"
								:error="error.dictType">
								<el-input
									v-model="dictForm.value"
									:placeholder="$t('addDictData.pDictValue')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item
								:label="$t('addDictData.dictSort')"
								prop="sort"
								:error="error.dictType">
								<el-input-number
									v-model="dictForm.sort"
									controls-position="right"
									@change="handleChange"
									:min="1"
									:max="100"></el-input-number>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item :label="$t('addDictData.notes')">
								<el-input
									type="textarea"
									:rows="4"
									v-model="dictForm.notes"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('dictForm')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "AddDictData",
	data() {
		return {
			labelPosition: "top",
			loadingForm: false,
			rules: {
				label: [
					{
						required: true,
						message: this.$t("addDictData.pDictLabel"),
						trigger: "blur",
					},
					{
						min: 1,
						max: 32,
						message: this.$t("addDictData.rDictLabel"),
						trigger: "blur",
					},
				],
				value: [
					{
						required: true,
						message: this.$t("addDictData.pDictValue"),
						trigger: "blur",
					},
					{
						min: 1,
						max: 64,
						message: this.$t("addDictData.rDictValue"),
						trigger: "blur",
					},
				],
			},
			error: {
				dictName: "",
				dictType: "",
			},
			clear: false,
			itemKey: "",
			loading: false,
		};
	},
	props: {
		dialogDict: Boolean,
		dictForm: Object,
		langList: Array,
	},
	mounted() {
		this.clear = false;
	},
	methods: {
		open() {
			console.log(this.dictForm, 111);
			this.langList.forEach(k => {
				k["disabled"] = k.value === this.dictForm.codesLabels[0].lang;
			});
			if (this.dictForm.id) {
				this.loading = true;
				this.$api
					.request(this.$url.DictData.listLabel, this.$method.get, {
						id: this.dictForm.id,
					})
					.then(res => {
						if (res.code === 0) {
							if (res.data.length > 0) {
								this.dictForm.codesLabels = res.data;
								this.langList.forEach(k => {
									res.data.forEach(d => {
										if (k.value === d.lang) {
											k["disabled"] = true;
										}
									});
								});
							} else {
								this.setLang();
							}
						}
						this.loading = false;
					})
					.catch(() => {
						this.loading = false;
					});
			}
		},

		closeDialog() {
			this.clearValidate("dictForm");
			if (this.dictForm.id) {
				this.$toolUtil.clearForm(this.dictForm);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.dictForm);
				}
			}
			this.cancel();
		},

		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.DictData.save;
					let method = this.$method.post;
					if (this.dictForm.id) {
						url = this.$url.DictData.update;
						method = this.$method.put;
					}
					this.$api
						.request(url, method, this.dictForm)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: this.dictForm.id
										? this.$t("addDictData.up")
										: this.$t("addDictData.save"),
									type: "success",
								});
								this.clear = true;
								this.cancel(this.dictForm.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.loadingForm = false;
						});
				} else {
					return false;
				}
			});
		},

		cancel(state, code) {
			this.$emit("cancel", false, state, code);
		},

		// 清除表单校验信息
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},

		addLang() {
			if (this.dictForm.codesLabels.length >= this.langList.length) {
				this.$message.warning("添加语言超出上限");
			} else {
				this.setLang();
			}
		},

		delLang(item) {
			let index = this.dictForm.codesLabels.indexOf(item);
			if (index !== -1) {
				this.dictForm.codesLabels.splice(index, 1);
			}
			if (item.lang) {
				for (let i = 0; i < this.langList.length; i++) {
					if (this.langList[i].value === item.lang) {
						this.langList[i]["disabled"] = false;
						this.itemKey = Math.random();
						break;
					}
				}
			}
		},

		setLang() {
			for (let i = 0; i < this.langList.length; i++) {
				if (!this.langList[i].disabled) {
					this.dictForm.codesLabels.push({
						lang: this.langList[i].value,
						name: "",
						key: Date.now(),
					});
					this.langList[i]["disabled"] = true;
					break;
				}
			}
		},

		changeMenu() {
			let arr = [];
			this.dictForm.codesLabels.forEach(k => {
				if (k.lang) {
					arr.push(k.lang);
				}
			});
			this.langList.forEach(k => {
				k["disabled"] = false;
			});
			arr.forEach(k => {
				this.langList.forEach(g => {
					if (k === g.value) {
						g["disabled"] = true;
					}
				});
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.add-dict-data .el-select .el-input {
	width: 130px;
}
.add-dict-data .add-lang .el-form-item__content {
	margin-left: 0 !important;
}
.add-dict-data .add-lang {
	.btn {
		width: 100%;
		border-radius: 4px;
		text-align: center;
		cursor: pointer;
		margin-top: 50px;
	}
	.add-btn {
		border: 1px dashed #409eff;
		color: #409eff;
	}
	.del-btn {
		border: 1px dashed #f56c6c;
		color: #f56c6c;
	}
}
.add-dict-data .menu-scroll {
	max-height: 200px;
	overflow-y: scroll;
	overflow-x: hidden;
}
</style>
